export const destroySession = () => {
	return {
		type: 'DESTROY',
		payload: {}
	}
}

export const setCToken = payload => {

    return {
        type : 'SET_USER_CTOKEN',
        payload
    }
}

export const redirectToDps = (url, email, password, dpsUid) => {

	let data = new FormData();
	data.append('email', email);
	data.append('password', password);
	data.append('dpsUid', dpsUid);

	return (dispatch) => {
		fetch(url+'/api/user/action/accessDPS',
		{
			method: "POST",
			body: data
		})
		.then((response) => {
			if (!response.ok) {
				throw Error(response.statusText);
			}

			return response;
		})
		.then((response) => response.json())
		.then((item) => {

			if(!item.error_message){
				dispatch(setCToken(item.cToken))
			}


		})
		.catch(() => {
			//dispatch();
		});
	};
}



// WEBPACK FOOTER //
// ./src/redux/actions/globalActions.js